import React from 'react';
import Box from '../../Box/Box.js';
import { useOverflow } from '../hooks/useOverflow.js';

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ScrollableRegion({
  'aria-labelledby': labelledby,
  children,
  ...rest
}) {
  const ref = React.useRef(null);
  const hasOverflow = useOverflow(ref);
  const regionProps = hasOverflow ? {
    'aria-labelledby': labelledby,
    role: 'region',
    tabIndex: 0
  } : {};
  return /*#__PURE__*/React.createElement(Box, _extends({}, rest, regionProps, {
    ref: ref,
    sx: {
      overflow: 'auto'
    }
  }), children);
}
ScrollableRegion.displayName = "ScrollableRegion";

export { ScrollableRegion };
